import { render, staticRenderFns } from "./SlidesPc.vue?vue&type=template&id=3e5eed8f&scoped=true&"
import script from "./SlidesPc.vue?vue&type=script&lang=js&"
export * from "./SlidesPc.vue?vue&type=script&lang=js&"
import style0 from "./SlidesPc.vue?vue&type=style&index=0&id=3e5eed8f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5eed8f",
  null
  
)

export default component.exports